import React from 'react'
import { Grid } from '@mui/material'
import { QuestionCircle as QuestionCircleIcon } from '@refera/ui-icons'

import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'
import IconButton from '_/components/svg/icon-button'

import { NumericInput } from '_/views/budget-view-v2/components/Inputs/NumericInput'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'
import { useDialog } from '_/hooks/use-dialog'
import useStyles from './styles'

const helpButtonDescription = (
  <span>
    Se você deixar o cliente optar por fazer só este serviço, indique neste campo o valor que será
    cobrado neste caso. <br />
    <br />
    Para maiores informações,{' '}
    <a
      target="_blank"
      href="https://refera.movidesk.com/kb/pt-br/article/531275/valor-para"
      rel="noreferrer"
    >
      clique aqui.
    </a>
  </span>
)

export function SingleServicePrice({ handleBlur = () => {} }) {
  const styles = useStyles()
  const { addProblemReadOnly } = useBudgetForm()
  const { closeDialog, showDialog } = useDialog()

  function handleDialog() {
    showDialog({
      description: helpButtonDescription,
      onApprove: closeDialog,
      customIcon: QuestionCircleIcon,
    })
  }

  return (
    <Grid className={styles.container}>
      <NumericInput
        label="Valor para executar só este serviço"
        name="singleServicePrice"
        disabled={addProblemReadOnly}
        onBlur={handleBlur}
      />
      <IconButton onClick={handleDialog} className={styles.helpButton}>
        <HelpOutlineOutlinedIcon className={styles.helpButton} />
      </IconButton>
    </Grid>
  )
}
